import { ApolloError } from '@apollo/client';
import {
  Box,
  Button,
  ButtonAppearance,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalSize,
  Text,
} from '@bechtel/gds';
import { SaveUserPreferencesError } from '@bechtel/types';
import { t, Trans } from '@lingui/macro';
import { map } from 'lodash';
import { FC } from 'react';

interface displaySettingsErrorProps {
  errors: SaveUserPreferencesError[] | ApolloError;
  close: () => void;
}

const getErrorMessage = (error: string) => {
  switch (error) {
    case SaveUserPreferencesError.INVALID_LANGUAGE:
      return <Trans>Invalid Language.</Trans>;
    case SaveUserPreferencesError.INVALID_UOM:
      return <Trans>Invalid UOM</Trans>;
    case SaveUserPreferencesError.SAVING_USER_PREFERENCE_FAILED:
      return <Trans>Unable to save users settings. Please close button and try again.</Trans>;

    default:
      return <Trans>An error has occured. Please close button and try again.</Trans>;
  }
};

export const DisplaySettingsError: FC<displaySettingsErrorProps> = ({ errors, close }) => {
  return (
    <Modal
      visible={true}
      size={ModalSize.DEFAULT}
      data-test-id="display-setting-error-modal"
      style={{ width: '552px', height: '275px' }}
    >
      <ModalHeader title={t`Display Settings Error`} />
      <ModalBody>
        <Box pb={{ sm: '500' }} flexGrow={{ sm: 1 }} flexDirection={{ sm: 'column' }}>
          {errors instanceof ApolloError && (
            <Box p={{ sm: '500' }}>
              <Text>
                <Trans>Network error has occured.Please close button and try again.</Trans>
              </Text>
            </Box>
          )}
          {errors instanceof Array &&
            map(errors, (error: SaveUserPreferencesError, index) => {
              return (
                <Box key={index} flexDirection={{ sm: 'column' }}>
                  <Box p={{ sm: '500' }} key={index}>
                    <Text size="400">{getErrorMessage(error)}</Text>
                  </Box>
                </Box>
              );
            })}
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
